module.exports = __webpack_public_path__ + "img/banner.4bcad4a7.png";